import { faWindowMaximize, faX } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ControlPosition, MapControl } from "@vis.gl/react-google-maps";
import NearByAssets from "../mapComponents/NearByAssets";
import HashTagFilter from "../mapComponents/HashTagFilter";
import CategoryFilter from "../mapComponents/CategoryFilter";
import useSrlHelper from "../../hooks/useSrlHelper";
import useAuth from "../../hooks/useAuth";

const ButtonsControl = ({
  report,
  nearbyItems,
  hashtag,
  setHashtag,
  category,
  setCategory,
  handleAll,
  showNearByAssets = true,
  showAllLabels = true,
  showHashTagFilter = false,
  showCategoryFilter = false,
}) => {
  const { isSrl } = useSrlHelper();
  const { user } = useAuth();
  const allowShowAllLabels = nearbyItems && nearbyItems.length <= 24;

  const onSetFilter = (tags) => {
    setHashtag(tags);
  };

  if (
    !showNearByAssets &&
    !showAllLabels &&
    !showHashTagFilter &&
    !showCategoryFilter
  )
    return null;

  return (
    <MapControl position={ControlPosition.LEFT_TOP}>
      <div
        // className="d-flex align-items-center bg-white rounded border border-black border-1"
        // style={{ width: "auto", margin: "10px", padding: "5px" }}
        className="d-flex align-items-center px-2"
        style={{
          background: "#ffffffff",
          width: "auto",
          margin: "10px",
          height: "40px",
          borderRadius: "2px",
          order: 1,
        }}
      >
        {showNearByAssets && <NearByAssets result={nearbyItems ?? []} />}
        {showAllLabels && user.role !== "Root" && (
          <div
            onClick={() => {
              allowShowAllLabels && handleAll && handleAll();
            }}
            className="cursor-pointer px-1"
          >
            <span className="fa-layers fa-fw mx-2">
              <FontAwesomeIcon
                // className="mx-2"
                title={"All labels"}
                // className="text-white bg-black"
                icon={faWindowMaximize}
                size={"lg"}
                color={"#293042"}
                fixedWidth
              />
              {!allowShowAllLabels && (
                <FontAwesomeIcon
                  // className="mx-2"
                  title={"Too many assets"}
                  // className="text-white bg-black"
                  icon={faX}
                  size={"lg"}
                  color={"#ff0000"}
                  fixedWidth
                />
              )}
            </span>
            {/* <FontAwesomeIcon
              className="mx-2"
              title={"All labels"}
              // className="text-white bg-black"
              icon={faWindowMaximize}
              size={"lg"}
              color={"#293042"}
              fixedWidth
            /> */}
          </div>
        )}
        {showHashTagFilter && !report && (
          <HashTagFilter onSetFilter={onSetFilter} showTags={hashtag} />
        )}
        {showCategoryFilter && isSrl() && !report && (
          <CategoryFilter
            selectedCategory={category}
            setSelectedCategory={setCategory}
          />
        )}
        {report && (
          <div className="badge bg-primary px-1 cursor-pointer">
            <span>Report:&nbsp;{report.name}</span>
          </div>
        )}
      </div>
    </MapControl>
  );
};

export default ButtonsControl;
